import { useEffect, useState } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

export function PoToast() {
  const toast = useAtomValue(AppAtoms.toastAtom);
  const setToast = useSetAtom(AppAtoms.toastAtom);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!toast) return;
    setVisible(true);
    const id = setTimeout(() => {
      setVisible(false);
      setToast(null);
    }, 4000);
    return () => clearTimeout(id);
  }, [toast?.rev, setToast]);

  if (!visible || !toast) return null;

  return (
    <div className="po-toast" data-testid="po-toast">
      <span className="toast-icon">
        {/* モックhtml L560-562逐語(JSX素svg) */}
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="9"/>
          <path d="m8.5 12 2.5 2.5 4.5-5"/>
        </svg>
      </span>
      {toast.message}
    </div>
  );
}
